export const adminsSelector = (state: any) => state.admins;
